import { useMemo } from 'react';

import { useProxyVmsVendorSource } from '@vlabs/api/point-api/client';
import type { VmsVendorSource } from '@vlabs/api/point-api/model';

import { buildArchiveRequest } from './buildArchiveRequest';

export interface ArchivePath {
  hls?: string;
  ws?: unknown;
  uiWsUrl?: string;
}

interface UseArchiveSourceResult {
  archivePath: ArchivePath | null;
  isLoading: boolean;
  isError: boolean;
}

export function useArchiveSource(
  vmsSource: VmsVendorSource | null,
  startTime?: string | null,
): UseArchiveSourceResult {
  const vendor = vmsSource?.vendor;
  const vendorUuid = vmsSource?.vendor_uuid;
  const isEnabled = !!vendor && !!vendorUuid && !!startTime;

  const params = useMemo(
    () => (isEnabled ? buildArchiveRequest(vendor, startTime) : undefined),
    [isEnabled, startTime, vendor],
  );
  const query = useProxyVmsVendorSource(vendor ?? '', vendorUuid ?? '', {
    request: { params },
    query: {
      enabled: isEnabled,
      queryKey: ['video-archive-source', vendor, vendorUuid, params],
      retry: false,
    },
  });

  return {
    archivePath: query.data?.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
